import { useEffect, useState } from "react";
import { smoothScroll } from "../../utils/helpers";
import up from "../../assets/icons/up.png";
import styles from "./ui.module.scss";

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 700) {
        setIsVisible(true);
      } else {
        return setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="scrollToTop"
      onClick={() => smoothScroll()}
      className={`${
        isVisible ? styles.scrollToTopVisible : styles.scrollToTop
      }`}
    >
      <img src={up} alt="up"/>
    </button>
  );
};
